import { LayoutModule } from '@angular/cdk/layout';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule, Title } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { JwtModule } from '@auth0/angular-jwt';

import { environment, jwtConfig } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AppMaterialModule } from './shared/app-material.module';
import { LoadingInterceptor } from './shared/interceptors/loading.interceptor';

import { MatTableModule } from '@angular/material/table';
import { SidenavModule } from './sidenav/sidenav.module';

import { NgxGoogleAnalyticsModule } from 'ngx-google-analytics';
import { DatePipe } from '@angular/common';

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    LayoutModule,
    HttpClientModule,
    AppMaterialModule,
    MatTableModule,
    JwtModule.forRoot({ config: jwtConfig }),
    AppRoutingModule,
    SidenavModule,
    NgxGoogleAnalyticsModule.forRoot(environment.gaId),
  ],
  entryComponents: [],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: LoadingInterceptor, multi: true },
    Title,
    DatePipe
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
